<template>
  <loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
    <SrcBackgroundScroll @scrolled="isShrunk = $event">
      <HeadlineSubScroll 
          :title="$t('settings.solar')" 
          target="/Settings" 
          :hassubline="!isShrunk"
          :hasmenu="false"
          :isShrunk="isShrunk"
          >
            <template #icon>
              <IconSolarPower             
                class="transition-all duration-300"
                :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
            </template>
            <template #subline>
              {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
            </template>
      </HeadlineSubScroll>


      <SettingsHeader :admin="this.$store.state.Role=='admin'">
        {{ this.decodeHtml(this.$store.state.WbName) }}
      </SettingsHeader>

      <SettingsBody>
        <template v-slot:formgrid>

            <ConfirmLeaveModal
              v-model:show="showLeaveDialog"
              :pendingNavigation="this.leaveDialog"
            />
            <div class="form-group mt-4 mb-2 sm:col-span-2">
              <ToggleWithLabel 
                v-model="solarcharge"
                :label="$t('setsolar.solaronoff')"
                :ontext="$t('common.on')"
                :offtext="$t('common.off')"
                @update:modelValue ="onChange"

              />
            </div>
            <div class="form-group mb-2 sm:col-span-2">
              <div class="border-b border-b-4 py-2 font-bold text-lg border-skin-b-list-bord">{{ $t('setsolar.settingsmartmeter') }}</div>           
            </div>
            <div class="form-group">
              <div class="w-full form-group mb-4">

                <SelectWithLabelIcon
                    v-model="smartmeter_id"
                    @update:model-value="selectsmartmeter(smartmeter_id)"
                    :disabled="!solarcharge"
                    :label="$t('setsolar.installedsm')"    
                    @update:modelValue ="onChange"
                  >
                  <template v-slot:options>
                    <option v-for="(smartmeter, index) in smartmeter_list" :key="index" :value="smartmeter.id">
                      <span v-if="smartmeter.supplier!=''">
                        {{smartmeter.supplier}}&nbsp;-&nbsp;
                      </span>                    
                      {{smartmeter.name}}
  
                    </option>
                  </template>
                </SelectWithLabelIcon>
              </div>
              
              <div v-if="solarcharge" class="form-group">
                <label class="font-medium text-sm text-skin-b-list-mute" for="SWversionen">{{ $t('setsolar.statussm') }}</label>
                <div id="SWversionen" class="font-semibold text-lg text-skin-b-list-mute 
                w-full mt-1 px-3 py-2 rounded-lg border-2 border-skin-b-list-bord"
                :class="{ 'bg-skin-b-list-head': smartmeterstatus==''||smartmeterstatus=='disabled',
                          'bg-orange-100': smartmeterstatus=='connecting',
                          'bg-red-100': smartmeterstatus=='disconnected'||smartmeterstatus=='error_ip'||smartmeterstatus=='error_port'||smartmeterstatus=='error_unitid'||smartmeterstatus=='error_smartmeter'||smartmeterstatus=='error_sunspec'||smartmeterstatus=='error_203',
                          'bg-green-100': smartmeterstatus=='connected' }">
                  {{ $t('setsolar.connectstatus',{status:smartmeterstatustxt}) }}
                </div> 
              </div>
              <div v-if="smartmeterstatus=='connected'&&solarcharge" class="form-group">
                <div id="SWversionen" class="font-semibold text-lg text-skin-b-list-mute 
                w-full mt-2 px-3 py-2 rounded-lg border-2 border-skin-b-list-bord"
                :class="{ 'bg-red-100': powergrid>=0,
                          'bg-green-100': powergrid<0 }">
                  <span v-if="powergrid<0">{{ $t('setsolar.powergridneg', { power: $n( powergrid*-1, 'decimal1' ) } ) }}</span>
                  <span v-if="powergrid>=0">{{ $t('setsolar.powergridpos', { power: $n( powergrid, 'decimal1' ) } ) }}</span>
                </div> 
              </div>
              <div class="my-4">
                <ToggleWithLabel 
                  v-model="smartmeterinvert"
                  :disabled="!solarcharge"
                  :label="$t('setsolar.invertsm')"
                  :ontext="$t('common.yes')"
                  :offtext="$t('common.no')"
                  @update:modelValue ="onChange"
                />
              </div>
          </div>
            
            <div class="form-group">
              <InputLabelError v-if="hasIpPort"
                v-model="smartmeter_ip"
                :disabled="!solarcharge"
                :label="$t('setsolar.ipadresssm')"
                :placeholder="$t('setsolar.ipadresssmph')"
                validationType="ip"
                :validator_off="!solarcharge&&hasIpPort"
                @valid="(status) => valid_smip = status"
                @update:modelValue ="onChange"
            />

              <InputLabelError v-if="hasIpPort"
                v-model="smartmeter_port"
                :disabled="!solarcharge"
                :label="$t('setsolar.portsm')"
                :placeholder="$t('setsolar.portsmph')"
                validationType="number"
                :validator_off="!solarcharge&&hasIpPort"
                @valid="(status) => valid_smport = status"
                @update:modelValue ="onChange"
              />     
              <div class="my-4">
                <ToggleWithLabel v-if="hasIpPort"
                  v-model="unitidauto"
                  @update:model-value="switchunitid()"
                  :disabled="!solarcharge&&hasIpPort"
                  :label="$t('setsolar.unitidauto')"
                  :ontext="$t('common.yes')"
                  :offtext="$t('common.no')"
                  @update:modelValue ="onChange"
                />
              </div>
              <InputLabelError
                v-if="!unitidauto&&hasIpPort"
                v-model="smartmeter_unitid"
                :disabled="!solarcharge"
                :label="$t('setsolar.unitidsm')"
                :placeholder="$t('setsolar.unitidsm')"
                validationType="number"
                :validator_off="!solarcharge&&hasIpPort"
                @valid="(status) => valid_unitid = status"
                @update:modelValue ="onChange"
              />
            </div>
            <div class="form-group mb-2 sm:col-span-2">
              <div class="border-b border-b-4 py-2 font-bold text-lg border-skin-b-list-bord">{{ $t('setsolar.settingcharging') }}</div>           
            </div>
            <div v-if="!minPower" class="form-group mt-4 mb-2 sm:col-span-2">
              <ToggleWithLabel 
                @update:model-value="selectakku(!homeakku)"
                v-model="homeakku"
                :disabled="!solarcharge"
                :label="$t('setsolar.homeakku')"
                :ontext="$t('common.yes')"
                :offtext="$t('common.no')"
                @update:modelValue ="onChange"
              />
          </div>        
            
          <div class="w-full form-group mb-4">
            <SelectWithLabelIcon
                v-model="smartmeter_phases"
                @update:model-value="selectphases(smartmeter_phases)"
                :disabled="!solarcharge"
                :label="$t('setsolar.countphase')"    
                @update:modelValue ="onChange"
              >
              <template v-slot:options>
                <option value="auto">{{ $t('common.automatic') }}</option>
                <option value="1">{{ $t('setsolar.countphase1') }}</option>
                <option value="3">{{ $t('setsolar.countphase3') }}</option>
              </template>
            </SelectWithLabelIcon>
          </div>
            
          <div v-if="!minPower" class="form-group">
            <InputLabelError 
                v-model="smartmeter_treshhold"
                :disabled="!solarcharge"
                :label="$t('setsolar.treshhold')"
                :placeholder="$t('setsolar.treshholdph')"
                validationType="number"
                :validator_off="!solarcharge"
                @valid="(status) => valid_treshhold = status"
                @update:modelValue ="onChange"
              />  
          </div>
          <div v-else class="form-group">
          </div>

          <div v-if="this.$store.state.WbApiVersion>=3.2" class="form-group mt-4 mb-2">
            <ToggleWithLabel 
                v-model="minPower"
                :disabled="!solarcharge"
                :label="$t('setsolar.minpower')"
                :ontext="$t('common.on')"
                :offtext="$t('common.off')"
                @update:modelValue ="onChange"
            />
          </div>

          <div v-if="minPower" class="form-group">
            <InputLabelError 
                v-model="minPowerValue"
                @focusout="checkminpower"
                :disabled="!solarcharge"
                :label="$t('setsolar.minpowervalue')"
                :placeholder="$t('setsolar.treshholdph')"
                validationType="number"
                :validator_off="!solarcharge"
                @valid="(status) => valid_minPower = status"
                @update:modelValue ="onChange"
              /> 
              <label class="font-medium text-sm text-skin-b-list-mute" for="adjustminpower">
                <span v-if="smartmeter_phases=='auto'">{{ $t('setsolar.minpowerhint', { power: 1380 } ) }}</span>
                <span v-if="smartmeter_phases=='1'">{{ $t('setsolar.minpowerhint', { power: 1380 } ) }}</span>
                <span v-if="smartmeter_phases=='3'">{{ $t('setsolar.minpowerhint', { power: 4140 } ) }}</span>
              </label>
          </div>

          <div v-if="minPower" class="form-group sm:col-span-2">

              <div class="form-group mb-4 block w-full px-4 py-3 font-semibold text-lg rounded-lg bg-skin-b-back sm:flex">

                <svg class="sm:inline-flex my-auto" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                  <path d="M80-240v-480h80v480H80Zm560 0-57-56 144-144H240v-80h487L584-664l56-56 240 240-240 240Z"/>
                </svg>
                <div class="px-4 text-center">
                  <p class="text-xs">{{ $t('setsolar.minpowera') }}</p>  
                  <p class="mx-auto">{{ $t('setsolar.powerwatt', { power: minPowerValue } ) }}</p>
                  <p class="text-xs">{{ $t('setsolar.minpowerb') }}</p>              
                </div>
                <div class="px-4 pt-4 sm:pt-0 text-left sm:w-2/3">
                  <p class="text-xs sm:text-base">{{ $t('setsolar.minpowertext', { power: minPowerValue } ) }}</p>            
                </div>
        
              </div> 
  
          </div>

          <div v-else class="form-group sm:col-span-2">
              <div v-if="homeakku&&calcpuffer" class="form-group mb-4">
                <p class="font-semibold">{{ $t('setsolar.treshholdbuffer', { buffer: akkupuffer } ) }}</p>
              </div> 

              <div class="form-group mb-4 block w-full px-4 py-3 font-semibold text-lg rounded-lg bg-skin-b-back flex">

                <svg class="inline-flex my-auto" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                  <path d="m80-80 80-400h640l80 400H80Zm40-740v-60h120v60H120Zm34 680h296v-110H176l-22 110Zm80-460-43-42 85-85 43 42-85 85Zm-46 290h262v-110H210l-22 110Zm292-390q-74 0-125-52.5T300-880h60q3 50 37 85t83 35q49 0 83-35t37-85h60q-4 75-55 127.5T480-700Zm0-180Zm-30 360v-120h60v120h-60Zm60 380h296l-22-110H510v110Zm0-170h262l-22-110H510v110Zm216-291-85-85 42-42 86 84-43 43Zm-6-219v-60h120v60H720Z"/>
                </svg>
                <div class="px-4 text-center">
                  <p class="text-xs">{{ $t('setsolar.surplusa') }}</p>  
                  <p class="mx-auto">{{ $t('setsolar.powerwatt', { power: smartmeter_treshhold } ) }}</p>
                  <p class="text-xs">{{ $t('setsolar.surplusb') }}</p>              
                </div>

                <svg v-if="calcgridpower>0||calcakkupower>0" class="inline-flex my-auto" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                  <path d="M450-450H200v-60h250v-250h60v250h250v60H510v250h-60v-250Z"/>
                </svg>              
                <svg v-if="calcgridpower>0" class="inline-flex my-auto ml-2" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                  <path d="M715-360v-60h95q13 0 21.5 8.5T840-390q0 12-8.5 21t-21.5 9h-95Zm0 160v-60h95q13 0 21.5 8.5T840-230q0 12-8.5 21t-21.5 9h-95Zm-155 40q-29 0-49.5-23.5T490-240h-95v-140h95q0-33 20.5-56.5T560-460h125v300H560ZM275-280q-67 0-111-43.5T120-435q0-68 44-111.5T275-590h65q33 0 54-21t21-54q0-33-21-54t-54-21H190q-12 0-21-9t-9-21q0-13 9-21.5t21-8.5h150q58 0 96.5 38.5T475-665q0 58-38.5 96.5T340-530h-65q-42 0-68.5 26T180-435q0 43 26.5 69t68.5 26h90v60h-90Z"/>
                </svg>
                <div v-if="calcgridpower>0" class="px-4 text-center">
                  <p class="text-xs">{{ $t('setsolar.grida') }}</p>  
                  <p class="">{{ $t('setsolar.powerwatt', { power: calcgridpower } ) }}</p>
                  <p class="text-xs">{{ $t('setsolar.gridb') }}</p>               
                </div>
                <svg v-if="calcakkupower>0" class="inline-flex my-auto ml-2" xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
                  <path d="M310-80q-13 0-21.5-8.5T280-110v-676q0-13 8.5-21.5T310-816h90v-64h160v64h90q13 0 21.5 8.5T680-786v333q-88 0-150.5 62.5T467-239q0 48 19.5 89T539-80H310Zm30-476h280v-200H340v200ZM660-87v-113h-80l120-192v112h80L660-87Z"/>
                </svg>
                <div v-if="calcakkupower>0" class="px-4 text-center">
                  <p class="text-xs">{{ $t('setsolar.akkua') }}</p>  
                  <p class="text-red-600">{{ $t('setsolar.powerwatt', { power: calcakkupower } ) }}</p>
                  <p class="text-xs">{{ $t('setsolar.akkub') }}</p>               
                </div>           
              </div> 
            </div>
  
      </template>
      <template v-slot:formbottom>
        <ActionButton :disabled="validSolar || !isDirty" @click="saveGeneral()">
          {{ $t('common.save') }}
        </ActionButton>
      </template>
    </SettingsBody>
  </SrcBackgroundScroll>
</template>
  
<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconSolarPower from './icons/IconSolarPower.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import ActionButton from './elements/ActionButton.vue'
import InputLabelError from './elements/InputLabelError.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import SelectWithLabelIcon from './elements/SelectWithLabelIcon.vue'
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { useI18n } from 'vue-i18n'
import ConfirmLeaveModal from './elements/ConfirmLeaveModal.vue'
  
  export function validName(name) {
    let validNamePattern = new RegExp("^[0-9]+(?:[-'\\S][0-9]+)*$");
    if (validNamePattern.test(name)){
      return true;
    }
    return false;
  }
  export function validIP(ipadress) {
    let validNamePattern = new RegExp("^((25[0-5]|(2[0-4]|1\\d|[1-9]|)\\d)(\\.(?!$)|$)){4}$");
    if (validNamePattern.test(ipadress)){
      return true;
    }
    return false;
  }
  
  export default {
    setup () {
      const { t,d,n } = useI18n()
      return { t,d,n, v$: useVuelidate() }
    }, 
    components: {
      SrcBackgroundScroll, HeadlineSubScroll, IconSolarPower,
      SettingsHeader, SettingsBody, ActionButton,
      InputLabelError, ToggleWithLabel, SelectWithLabelIcon, ConfirmLeaveModal
      },
    validations() {
      return {
        smartmeter_ip: {
        required: helpers.withMessage('', required), 
        name_validation: {  $validator: validIP,  $message: this.$t('setsolar.ipadresssmerror') },
      },
      smartmeter_port: {
        required: helpers.withMessage('', required), 
        name_validation: {   $validator: validName,  $message: this.$t('setsolar.portsmerror') },
      },
      smartmeter_treshhold: {
        required: helpers.withMessage('', required), 
        name_validation: {   $validator: validName,  $message: this.$t('setsolar.portsmerror') },
      },
      minPowerValue: {
        required: helpers.withMessage('', required), 
        name_validation: {   $validator: validName,  $message: this.$t('setsolar.portsmerror') },
      },
      }
    },  
    data() {
      return {
            isLoading: false,
            polling: true,
            solarcharge: false,
            homeakku: false,
            smartmeterinvert: false,
            unitidauto: true,
            minPower: false,
            minPowerValue: 0,
            valid_minPower: false,
            saveto: this.$store.state.WbId,
            smartmeterstatus: '',
            smartmeterstatustxt: '',
            powergrid: 0,          
            smartmeter_name: 'Smartmeter A',
            smartmeter_id: '',
            smartmeter_ip: '',
            valid_smip: false,
            smartmeter_port: 0,
            valid_smport: false,
            smartmeter_unitid: -2,
            valid_unitid: false,
            smartmeter_phases: '1',
            smartmeter_treshhold: 0,
            valid_treshhold: false,
            akkupuffer: 200,
            smartmeter_hysteresis: 0,
            smartmeter_adjusttime: 0,
            smartmeter_adjusttyp: 0,
            smartmeter_list: [],
            client_status: [],
            pvself_tbl: [],
            isShrunk: false,

            isDirty:false,
            showLeaveDialog:false
      }
    },
    beforeRouteLeave(to, from, next) {
      if (this.isDirty) {
        this.showLeaveDialog = true;
        this.pendingNavigation = next;    
      } else {
        next();
      }
    },
    computed: {
      //validSolar(){// v$.smartmeter_ip.$invalid||v$.smartmeter_port.$invalid||v$.smartmeter_treshhold.$invalid||v$.minPowerValue.$invalid
      //if((this.solarcharge&&!this.minPower&&this.valid_smip&&this.valid_smport&&this.valid_treshhold)||
      //  (this.solarcharge&&this.minPower&&this.valid_smip&&this.valid_smport&&!this.v$.minPowerValue.$invalid))
      //    return false;
      //  else
      //    return true;
      validSolar() {
        // If solarcharge is active, always return true
        if (!this.solarcharge) return false;

        // Ensure the necessary validation variables exist
        let hasValidIp = this.valid_smip;
        let hasValidPort = this.valid_smport;
        const hasValidThreshold = this.valid_treshhold;
        const hasValidMinPower = !this.v$.minPowerValue.$invalid;
        if(this.smartmeter_id==='12'){
          hasValidIp = true;
          hasValidPort = true;
        }
        // Validation logic
        return !(
          (this.solarcharge && !this.minPower && hasValidIp && hasValidPort && hasValidThreshold) ||
          (this.solarcharge && this.minPower && hasValidIp && hasValidPort && hasValidMinPower)
        );
      },
      hasIpPort() {
        return this.smartmeter_id !== '12';
      },
      calcgridpower(){
        if(!this.homeakku){
            if(this.smartmeter_phases=='auto'||this.smartmeter_phases=='1'){
              if(this.smartmeter_treshhold<1380)
                return 1380 - this.smartmeter_treshhold;
              else
                return 0;
            }else if(this.smartmeter_phases=='3'){
              if(this.smartmeter_treshhold<4140)
                return 4140 - this.smartmeter_treshhold;
              else
                return 0;
            }else
              return 0;  
        }else{
          return 0;
        }
      },
      calcakkupower(){
        if(this.homeakku){
            if(this.smartmeter_phases=='auto'||this.smartmeter_phases=='1'){
              if(this.smartmeter_treshhold<(1380+this.akkupuffer))
                return 1380+this.akkupuffer-this.smartmeter_treshhold;
              else
                return 0;
            }else if(this.smartmeter_phases=='3'){
              if(this.smartmeter_treshhold<(4140+this.akkupuffer))
                return 4140+this.akkupuffer-this.smartmeter_treshhold;
              else
                return 0;
            }else
              return 0; 
        }else{
          return 0;
        }
      },
      calcpuffer(){
        if(this.smartmeter_phases=='auto'||this.smartmeter_phases=='1'){  
          if(this.smartmeter_treshhold<=(1380+this.akkupuffer))
                return true;
              else
                return false;
        }else if(this.smartmeter_phases=='3'){
          if(this.smartmeter_treshhold<=(4140+this.akkupuffer))
                return true;
              else
                return false;
        }else{
          return false;
        }
      }
    },
    methods: {
      onChange() {this.isDirty = true;},
      leaveDialog(){this.pendingNavigation();},

      decodeHtml: function(html) {
        let txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
        },
      switchunitid(){
          if(this.unitidauto)
            this.smartmeter_unitid=-2;
          else if(this.smartmeter_unitid<0)
            this.smartmeter_unitid=0;
        },
      selectakku(value){
        console.log('homeakku state: '+this.homeakku);
        console.log('homeakku übergeben: '+value);
        if(value){
          if(this.smartmeter_phases=='auto'||this.smartmeter_phases=='1')
          this.smartmeter_treshhold = 1380 + this.akkupuffer;
          if(this.smartmeter_phases=='3')
          this.smartmeter_treshhold = 4140 + this.akkupuffer;
        }else{
          if(this.smartmeter_phases=='auto'||this.smartmeter_phases=='1')
          this.smartmeter_treshhold = 1380;
          if(this.smartmeter_phases=='3')
          this.smartmeter_treshhold = 4140;
        }
      },
      selectphases(phases){
        if(this.homeakku){
          if(phases=='auto'||phases=='1')
            this.smartmeter_treshhold = 1380 + this.akkupuffer;
          if(phases=='3')
            this.smartmeter_treshhold = 4140 + this.akkupuffer; 
        }else{
          if(phases=='auto'||phases=='1')
            this.smartmeter_treshhold = 1380;
          if(phases=='3')
            this.smartmeter_treshhold = 4140;        
        }      
  
      },
      selectsmartmeter(id){
        this.smartmeter_port = this.smartmeter_list[this.smartmeter_list.findIndex(sm => sm.id == id)].port;
      },
      checkminpower(){
        if(this.smartmeter_phases=='auto'){  
          if(this.minPowerValue<1380)
            this.minPowerValue = 1380;
          if(this.minPowerValue>11040)
            this.minPowerValue = 11040;
        }else if(this.smartmeter_phases=='1'){
          if(this.minPowerValue<1380)
            this.minPowerValue = 1380;
          if(this.minPowerValue>3680)
            this.minPowerValue = 3680;
        }else if(this.smartmeter_phases=='3'){
          if(this.minPowerValue<4140)
            this.minPowerValue = 4140;
            if(this.minPowerValue>11040)
            this.minPowerValue = 11040;
        }
      },
      saveGeneral() {
        this.isDirty = false;
        this.polling=false;
        if(this.solarcharge)
          this.pvself_tbl.enabled=1;
        else
          this.pvself_tbl.enabled=0;
        if(this.smartmeterinvert)
          this.pvself_tbl.invers=1;
        else
          this.pvself_tbl.invers=0;
        if(this.homeakku)
          this.pvself_tbl.storage='available';
        else
          this.pvself_tbl.storage='non';

        if(this.minPower)
          this.checkminpower();
        else
          this.minPowerValue=0;
        this.axios
                .get('wallbox/settings.php?action=sync_consumption&client='+this.saveto+'&active='+this.pvself_tbl.enabled+'&smartmeter='+this.smartmeter_id+'&invers='+this.pvself_tbl.invers+'&port='+this.smartmeter_port+'&ip='+this.smartmeter_ip+'&phases='+this.smartmeter_phases+'&storage='+this.pvself_tbl.storage+'&unit_id='+this.smartmeter_unitid+'&threshhold='+this.smartmeter_treshhold+'&minPower='+this.minPowerValue+'&user='+this.$store.state.token)
                .then((response) => {         
                            if(response.data.status=='ok'){
                              console.log('Save PV');
                              this.polling=true;
                              this.updatePage();
                            }else{
                              console.log('Error Save PV');                   
                            }
                          })
                .catch((errors) => {
                  console.log(errors); // Errors
                });
      },
      updatePage(){
        this.isLoading = true;
        let selfpv_tblUrl = 'wallbox/info.php?action=get_selfconsumption&user='+this.$store.state.token+'&client='+this.saveto; //minPower
        let smartmeter_listUrl = 'wallbox/info.php?action=get_smartmeter&user='+this.$store.state.token+'&client='+this.saveto;
        let client_statusUrl = 'wallbox/info.php?action=get_status&user='+this.$store.state.token+'&client='+this.saveto;
        const requestselfpv_tbl = this.axios.get(selfpv_tblUrl);  
        const requestsmartmeter_list = this.axios.get(smartmeter_listUrl);
        const requestclient_status = this.axios.get(client_statusUrl);
        this.axios
            .all([requestselfpv_tbl,requestsmartmeter_list,requestclient_status])
            .then(
                this.axios.spread((...responses) => {
                    const responseselfpv_tbl = responses[0];
                    const responsesmartmeter_list = responses[1];
                    const responseclient_status = responses[2];
  
                    if(responseselfpv_tbl.data.status=='token'){
                          this.$router.push({path: '/'});             
                    }else if(responseselfpv_tbl.data.status=='ok'){
                      this.pvself_tbl = responseselfpv_tbl.data.tbl_selfconsumption;
                      if(this.pvself_tbl.enabled==1)
                        this.solarcharge = true;
                      else
                        this.solarcharge = false;
                      if(this.pvself_tbl.invers==1)
                        this.smartmeterinvert = true;
                      else
                        this.smartmeterinvert = false;                    
                      if(this.pvself_tbl.storage=='available')
                        this.homeakku = true;
                      if(this.pvself_tbl.storage=='non')
                        this.homeakku = false;
                      if(this.pvself_tbl.minPower==0){
                        this.minPower = false;
                        this.minPowerValue = 0;
                      }else{
                        this.minPower = true;
                        this.minPowerValue = this.pvself_tbl.minPower;
                      }
                      if(this.pvself_tbl.unitID==-2)
                        this.unitidauto=true;
                      else
                        this.unitidauto=false;               
                      this.smartmeter_id = String(this.pvself_tbl.smartmeter);
                      this.smartmeter_ip = this.pvself_tbl.ip;
                      this.smartmeter_port = this.pvself_tbl.port;
                      this.smartmeter_unitid = this.pvself_tbl.unitID;
                      this.smartmeter_phases = this.pvself_tbl.phases;
                      this.smartmeter_treshhold = this.pvself_tbl.threshhold;
                      this.smartmeter_hysteresis = this.pvself_tbl.hysteresis;
                      this.smartmeter_adjusttime = this.pvself_tbl.adjustmentSec;
                      this.smartmeter_adjusttyp = this.pvself_tbl.adjustmentTyp;
                    }else{
                      console.log('Error get self consumption Table');
                    }
                    if(responsesmartmeter_list.data.status=='token'){
                          this.$router.push({path: '/'});             
                    }else if(responsesmartmeter_list.data.status=='ok'){
                      if(responsesmartmeter_list.data.tbl_smartmeter!=''){
                        this.smartmeter_list = responsesmartmeter_list.data.tbl_smartmeter.sort((a,b) => a.id - b.id);
                        this.smartmeter_list.forEach(item => {
                            if(item.name=='SunSpec'){
                                item.name=this.$t('setsolar.sunspec');
                            }
                            item.name = this.decodeHtml(item.name);
                            item.supplier = this.decodeHtml(item.supplier);
                          });
                      }else{
                        console.log('Smartmeter List Table ist leer');
                      }
                    }else{
                      console.log('Error get Smartmeter List Table');
                    }
  
                    if(responseclient_status.data.status=='token'){
                          this.$router.push({path: '/'});             
                    }else if(responseclient_status.data.status=='ok'){
                      this.client_status = responseclient_status.data.tbl_status;  
                      this.smartmeterstatus = this.client_status.smartmeterStatus;
                      this.powergrid = this.client_status.powerGrid;
                      this.pollData();
                    }else{
                      console.log('Error get client status Table');
                    }
                this.isLoading = false;
                })
            )
            .catch((errors) => {
                this.isLoading = false;
                console.error(errors);
            });
      },
      pollData () {
          if(this.polling){
            console.log('get Polldata status');
            this.axios
            .get('wallbox/info.php?action=get_status&user='+this.$store.state.token+'&client='+this.saveto)
            .then((response) => {         
                    if(response.data.status=='ok'){
                      this.client_status = response.data.tbl_status;  
                      this.smartmeterstatus = this.client_status.smartmeterStatus;
                      if(this.smartmeterstatus==''||this.smartmeterstatus=='disabled')
                        this.smartmeterstatustxt = '';
                      else if(this.smartmeterstatus=='connecting')
                        this.smartmeterstatustxt = this.$t('common.connecting');
                      else if(this.smartmeterstatus=='disconnected')
                        this.smartmeterstatustxt = this.$t('common.disconnected');
                      else if(this.smartmeterstatus=='connected')
                        this.smartmeterstatustxt = this.$t('common.connected');
                      else if(this.smartmeterstatus=='error_ip')
                        this.smartmeterstatustxt = this.$t('setsolar.error_ip');
                      else if(this.smartmeterstatus=='error_port')
                        this.smartmeterstatustxt = this.$t('setsolar.error_port');
                      else if(this.smartmeterstatus=='error_unitid')
                        this.smartmeterstatustxt = this.$t('setsolar.error_unitid');
                      else if(this.smartmeterstatus=='error_sunspec')
                        this.smartmeterstatustxt = this.$t('setsolar.error_sunspec');
                      else if(this.smartmeterstatus=='error_smartmeter')
                        this.smartmeterstatustxt = this.$t('setsolar.error_smartmeter');
                      else if(this.smartmeterstatus=='error_203')
                        this.smartmeterstatustxt = this.$t('setsolar.error_203');
                      this.powergrid = this.client_status.powerGrid;
                      (response.data.status=='ok') ? setTimeout(() => {  this.execpoll(this.polling); }, 1000) : null
                    }else{
                      console.log('Error get client status Table');
                    }
                      })
            .catch((errors) => {
                console.log(errors); // Errors
                this.execpoll(this.polling);
                      });
          }
        },
        execpoll(polling){
          if(polling){
          this.pollData();        
          }
        }   
    },
    beforeUnmount() {
      this.polling=false;
    },
    created() {  
        this.isLoading = true;
        let selfpv_tblUrl = 'wallbox/info.php?action=get_selfconsumption&user='+this.$store.state.token+'&client='+this.saveto;
        let smartmeter_listUrl = 'wallbox/info.php?action=get_smartmeter&user='+this.$store.state.token+'&client='+this.saveto;
        let client_statusUrl = 'wallbox/info.php?action=get_status&user='+this.$store.state.token+'&client='+this.saveto;
        const requestselfpv_tbl = this.axios.get(selfpv_tblUrl);  
        const requestsmartmeter_list = this.axios.get(smartmeter_listUrl);
        const requestclient_status = this.axios.get(client_statusUrl);
        this.axios
            .all([requestselfpv_tbl,requestsmartmeter_list,requestclient_status])
            .then(
                this.axios.spread((...responses) => {
                    const responseselfpv_tbl = responses[0];
                    const responsesmartmeter_list = responses[1];
                    const responseclient_status = responses[2];
  
                      if(responseselfpv_tbl.data.status=='token'){
                          this.$router.push({path: '/'});             
                      }else if(responseselfpv_tbl.data.status=='ok'){
                      this.pvself_tbl = responseselfpv_tbl.data.tbl_selfconsumption;  
                      if(this.pvself_tbl.enabled==1)
                        this.solarcharge = true;
                      else
                        this.solarcharge = false;
                      if(this.pvself_tbl.invers==1)
                        this.smartmeterinvert = true;
                      else
                        this.smartmeterinvert = false;
                      if(this.pvself_tbl.storage=='available')
                        this.homeakku = true;
                      if(this.pvself_tbl.storage=='non')
                        this.homeakku = false;
                      if(this.pvself_tbl.minPower==0){
                        this.minPower = false;
                        this.minPowerValue = 0;
                      }else{
                        this.minPower = true;
                        this.minPowerValue = this.pvself_tbl.minPower;
                      }       
                      if(this.pvself_tbl.unitID==-2)
                        this.unitidauto=true;
                      else
                        this.unitidauto=false;       
                      this.smartmeter_id = String(this.pvself_tbl.smartmeter);
                      this.smartmeter_ip = this.pvself_tbl.ip;
                      this.smartmeter_port = this.pvself_tbl.port;
                      this.smartmeter_unitid = this.pvself_tbl.unitID;
                      this.smartmeter_phases = this.pvself_tbl.phases;
                      this.smartmeter_treshhold = this.pvself_tbl.threshhold;
                      this.smartmeter_hysteresis = this.pvself_tbl.hysteresis;
                      this.smartmeter_adjusttime = this.pvself_tbl.adjustmentSec;
                      this.smartmeter_adjusttyp = this.pvself_tbl.adjustmentTyp;
                    }else{
                      console.log('Error get self consumption Table');
                    }
  
                    if(responsesmartmeter_list.data.status=='token'){
                          this.$router.push({path: '/'});             
                    }else if(responsesmartmeter_list.data.status=='ok'){
                      if(responsesmartmeter_list.data.tbl_smartmeter!=''){
                        this.smartmeter_list = responsesmartmeter_list.data.tbl_smartmeter.sort((a,b) => a.alphaOrder - b.alphaOrder);
                        this.smartmeter_list.forEach(item => {
                            if(item.name=='SunSpec'){
                              item.name=this.$t('setsolar.sunspec');
                            }
                            item.name = this.decodeHtml(item.name);
                            item.supplier = this.decodeHtml(item.supplier);
                          });
                          console.log(this.smartmeter_list);
                      }else{
                        console.log('Smartmeter List Table ist leer');
                      }
                    }else{
                      console.log('Error get Smartmeter List Table');
                    }
  
                    if(responseclient_status.data.status=='token'){
                          this.$router.push({path: '/'});             
                    }else if(responseclient_status.data.status=='ok'){
                      this.client_status = responseclient_status.data.tbl_status;  
                      this.smartmeterstatus = this.client_status.smartmeterStatus;
                      if(this.smartmeterstatus==''||this.smartmeterstatus=='disabled')
                        this.smartmeterstatustxt = '';
                      else if(this.smartmeterstatus=='connecting')
                        this.smartmeterstatustxt = this.$t('common.connecting');
                      else if(this.smartmeterstatus=='disconnected')
                        this.smartmeterstatustxt = this.$t('common.disconnected');
                      else if(this.smartmeterstatus=='connected')
                        this.smartmeterstatustxt = this.$t('common.connected');
                      else
                        this.smartmeterstatustxt = this.$t('common.connected');
                      this.powergrid = this.smartmeterstatus;
                      this.pollData();
                    }else{
                      console.log('Error get client status Table');
                    }
                this.isLoading = false;
                })
            )
            .catch((errors) => {
                this.isLoading = false;
                console.error(errors);
            });
    },
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style src="@vueform/toggle/themes/default.css"></style>
  <style scoped>
  </style>
  